import { useLingui } from '@lingui/react'
import classNames from 'clsx'
import {
  arrayOf,
  bool,
  func,
  number,
  oneOfType,
  shape,
  string,
} from 'prop-types'

import IconTick from 'views/components/atoms/Icon/IconTick'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'
import { isUseMarketplaceVolumeBasedPricesEnabled } from 'views/utils/featureToggleUtils'

import VolumePricingLabelQuantitySelection from './VolumePricingQuantitySelection/VolumePricingLabelQuantitySelection'
import './VolumePricingQuantitySelection/VolumePricingLabelQuantitySelection.scss'

const OptionContent = ({
  value,
  text,
  disabled,
  title,
  isSelected,
  allowLinks,
  isInStock,
  upid,
  volumePricing,
  ...props
}) => {
  const { i18n } = useLingui()

  const {
    publicRuntimeConfig: {
      pageProperties: { featureToggles },
    },
  } = useShopAndRuntimeConfig()

  const isVolumePricingAvailable =
    isUseMarketplaceVolumeBasedPricesEnabled(featureToggles) &&
    volumePricing?.length > 1

  const isLink = allowLinks && !title

  const itemClassName = classNames(
    'm-Select__item l-flex l-flex--distribute-space u-font-weight--bold u-color--dark u-position--relative',
    {
      'm-Select__item--selectable': !disabled,
      'm-Select__item--disabled': disabled,
      'm-Select__item--selected m-Select__item--highlighted': isSelected,
      'u-background-color--greyLight m-Select__item--title': title,
      'u-color--grey': !isInStock,
      'm-Select__item--volume-pricing': isVolumePricingAvailable,
      'm-Select__item--link': isLink,
    }
  )
  const Container = isLink ? 'a' : 'div'
  const linkProps = isLink
    ? {
        href: value,
        'aria-label': `${text} - ${i18n._('general.link.to')} ${value}`,
      }
    : {}

  const BasicSelectContainer = () => {
    return (
      <Container {...props} className={itemClassName} {...linkProps}>
        <span>{text}</span>
        <div className="m-Select__item--icon u-transform-center--y">
          <IconTick size="small" className="u-color--positive" />
        </div>
      </Container>
    )
  }

  return isVolumePricingAvailable ? (
    <div className="m-Select__item--volume-pricing rebranding">
      <BasicSelectContainer />
      <div className="m-Select__item--selectable m-select__quantity-label--container">
        <VolumePricingLabelQuantitySelection
          value={value}
          volumePricing={volumePricing}
        />
      </div>
    </div>
  ) : (
    <BasicSelectContainer />
  )
}

OptionContent.propTypes = {
  className: string,
  value: oneOfType([string, number]),
  isSelected: bool,
  onClick: func,
  title: bool,
  disabled: bool,
  allowLinks: bool,
  text: string,
  isInStock: bool,
  upid: string,
  volumePricing: arrayOf(shape({})),
  basePrice: number,
  linkProps: shape({}),
}

OptionContent.defaultProps = {
  className: '',
  value: '',
  isSelected: false,
  onClick: null,
  title: false,
  disabled: false,
  allowLinks: false,
  text: '',
  isInStock: true,
  volumePricing: null,
  basePrice: null,
  linkProps: {},
}

export default OptionContent
